// Preloader functions
page.init();




